__webpack_require__.p = "/betting-resources/_next/";